import { FileClassificationStatus } from "@inrev/common";

export const CLASSIFICATION_POLL_INTERVAL_MS = 15_000; // 15 seconds

export const CLASSIFICATION_POLL_MAX_MS = 5 * 60 * 1_000; // 5 minutes

export const isClassificationPendingStatus = (
	status: FileClassificationStatus | undefined,
): boolean =>
	status === FileClassificationStatus.pending || status === FileClassificationStatus.not_started;
